import React from "react";
import {SwatchProps} from "../types";
import {SquareCustomColorSwatch} from "./custom-color-swatches";
import {SquareImageSwatch} from "./image-swatches";

export const SquareSwatch = (props: SwatchProps) => {
  const {boxShadow, selected, size, colorName} = props;
  //  eslint-disable-next-line react/destructuring-assignment
  const url = "url" in props ? props.url : undefined;
  //  eslint-disable-next-line react/destructuring-assignment
  const customColor = "customColor" in props ? props.customColor : undefined;
  return "customColor" in props ? (
    <SquareCustomColorSwatch
      aria-hidden
      boxShadow={boxShadow}
      customColor={customColor}
      selected={selected}
      size={size}
      title={colorName}
    />
  ) : (
    <SquareImageSwatch
      aria-hidden
      boxShadow={boxShadow}
      selected={selected}
      size={size}
      src={url}
      title={colorName}
    />
  );
};
